export default __webpack_public_path__ + "static/media/fMaltoBuza17.261049b7.png";